import { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import { t } from 'i18next'

import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import DialogContent from 'src/components/shared/ui/DialogContent'
import DialogTitle from 'src/components/shared/ui/DialogTitle/DialogTitle'
import { useAlertContext } from 'src/contexts/AlertContext'
import { Mensaje } from 'src/interfaces'
import AssignExpedient from './components/AssignExpedient'
import useStyles from './useStyles'

type Props = {
  message: Mensaje
  isOpened: boolean
  onCloseDialog: () => void
}

function AsignarExpedienteDialog({ message, isOpened, onCloseDialog }: Props): JSX.Element | null {
  const [success, setSuccess] = useState(false)
  const classes = useStyles({ success })
  const { addAlert } = useAlertContext()

  function onAssigned() {
    setSuccess(true)
  }

  function onClose() {
    setSuccess(false)
    onCloseDialog()
  }

  useEffect(() => {
    if (isOpened && success) {
      addAlert({
        message: t('dialog.message.notificacion_clasificada'),
        type: AlertType.SUCCESS,
        closeAction: onClose
      })
    }
    // eslint-disable-next-line
  }, [success, isOpened])

  return !success ? (
    <Dialog
      onClose={onClose}
      open={isOpened}
      fullWidth={!success}
      maxWidth="md"
      fullScreen={false}
      className={classes.container}
    >
      <DialogTitle id="asignar-expediente" className={classes.dialogTitle}>
        {t('dialog.message.clasificar_notificacion')}
      </DialogTitle>
      {isOpened && (
        <DialogContent className={classes.content} dividers>
          <AssignExpedient onAssigned={onAssigned} message={message} onCancel={onCloseDialog} />
        </DialogContent>
      )}
    </Dialog>
  ) : null
}

export default AsignarExpedienteDialog
